import React from "react";

const NewsPageAllNews = (props) => {
    return (
        <div className="col-lg-4 col-md-6">
            <div className="blog-item card border-0 mt-30 bg-light-gray">
                <img src={process.env.PUBLIC_URL + "/assets/images/News/" + props.newsItem.imgLink} alt="" className="img-fluid mr-3 mb-20" />
                <div className="blog-meta small">
                        <span className="font-w-600 mr-3"><span className="fas fa-calendar-alt text-primary mr-2 mb-10" />{props.newsItem.date}</span>
                    </div>
                <a target="_blank" rel="noopener noreferrer " href={props.newsItem.href} className="h4 text-dark mb-20">{props.newsItem.title}</a>
            </div>
        </div>
    );
}

export default NewsPageAllNews;